<template>
  <div v-if="!isOnline" class="error-box">
    {{ $t("identification.no_internet_connection") }}
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { actions, getters } from "@/store";
import { AppNotification } from "@/constants/appNotification";

export default {
  data() {
    return {
      offlineNotification: {
        id: AppNotification.OfflineWorkerDetected,
        title: "It seems that you are offline",
        message: "Please check your network connection",
        actions: [{ label: "Dismiss" }]
      },
      onlineNotification: {
        id: AppNotification.OfflineOnline,
        title: "Network connection has been restored",
        actions: [{ label: "Dismiss" }]
      }
    };
  },
  computed: {
    ...mapGetters([getters.isOnline])
  },
  methods: {
    ...mapActions([
      actions.notificationAdd,
      actions.notificationDismiss,
      actions.toggleOnline
    ]),
    handleOnlineChange() {
      if (navigator.onLine) {
        this.toggleOnline(true);
        this.notificationAdd(this.onlineNotification);
        this.notificationDismiss(this.offlineNotification);
      } else {
        // Let SignalR restore the session, or close it after retries run out.
        this.toggleOnline(false);
        this.notificationAdd(this.offlineNotification);
      }
    }
  },
  mounted() {
    this.toggleOnline(navigator.onLine);
    window.addEventListener("online", this.handleOnlineChange);
    window.addEventListener("offline", this.handleOnlineChange);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.handleOnlineChange);
    window.removeEventListener("offline", this.handleOnlineChange);
  }
};
</script>
<style scoped>
.error-box {
  position: absolute;
  top: 1rem;
  left: 50%;
  box-sizing: border-box;
  width: 95%;
  height: 3rem;
  padding: 1rem;
  font-weight: bold;
  color: var(--error-box-color);
  background: var(--error-box-background);
  transform: translateX(-50%);
}
</style>
